import { Transforms, Editor } from 'slate';
import { CustomEditor, StyledParagraphElement } from 'slate/types/slate';
import { isStyledParagraph } from './isStyledParagraph';

export const unWrapStyledParagraph = (editor: CustomEditor, id?: string) => {
  const [match] = Editor.nodes(editor, {
    at: [],
    match: (n) => isStyledParagraph(n) && n.id === id,
  });

  if (!match) return;

  const [, path] = match;
  Transforms.unwrapNodes(editor, {
    at: path,
    match: isStyledParagraph,
  });
};

export const isInsideStyledParagraph = (editor: CustomEditor): StyledParagraphElement | null => {
  if (!editor.selection) return null;
  const [match] = Editor.nodes(editor, {
    match: isStyledParagraph,
  });
  return match ? (match[0] as StyledParagraphElement) : null;
};

export const toggleConnect = (editor: CustomEditor, id: string, currentStyle: Record<string, unknown> | undefined) => {
  const [match] = Editor.nodes(editor, {
    match: (n) => isStyledParagraph(n) && n.id === id,
  });

  if (match) {
    const [, path] = match;
    const [node] = Editor.node(editor, path);
    const connected = isStyledParagraph(node) ? node.connected ?? true : true;

    if (connected) {
      Transforms.setNodes(editor, { connected: false, currentStyle }, { at: path });
    } else {
      Transforms.setNodes(editor, { connected: true, currentStyle }, { at: path });
    }
  }
};
